<template>
  <div id="shopping_movies" class="cts_box anchor_point" v-if="sns_post_sales && sns_post_sales.length">
    <h2 class="sub_ttl"><span>動画レンタル履歴</span></h2>
    <div class="txt_btn flex">
      <p class="lead_txt">
        動画レンタルの履歴を表示しています。
      </p>
      <div class="button_wrap">
        <router-link :to="{ name: 'SnsPostSalesHistories'}" class="submit light skeleton">動画レンタル履歴</router-link>
      </div>
    </div>

    <div class="online_shop_box">
      <div class="order_group" v-for="sale in sns_post_sales" v-bind:key="sale.id">
        <ul class="online_shop_list movie">
          <li>
            <div class="buy_data movie flex">
              <div class="mov_details">
                <table>
                  <tbody>
                  <tr class="head">
                    <th class="date">ご注文日</th>
                    <th class="price">金額</th>
                    <th class="sns_post">視聴可能期間</th>
                  </tr>
                  <tr>
                    <td class="date"><span class="sp">ご注文日：</span>{{ moment(sale.payment_at, 'YYYY年MM月DD日') }}</td>
                    <td class="price"><span class="sp">金額：</span>¥ {{ delimited(sale.price) }}</td>
                    <td class="access_period_at">
                      <template v-if="sale.access_period_at"><span class="sp">視聴可能期間：</span>
                        {{ moment(sale.access_period_at, 'YYYY年M月D日') }}まで
                      </template>
                      <template v-else>
                        ※ 無制限
                      </template>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <h3>{{ sale.sns_post_sale.title }}</h3>
              </div>
              <div class="btn" v-if="sale.readable">
                <router-link :to="{ name: 'SnsPost', params: {post_id: sale.sns_post_sale.sns_post_id} }" class="linkBtn">
                  視聴する
                </router-link>
              </div>
              <div class="btn" v-else>
                <router-link :to="{ name: 'SnsPostSale', params: {id: sale.sns_post_sale.id} }" class="linkBtn green">
                  再レンタルする
                </router-link>
              </div>
            </div>
<!--            <div class="detail flex">-->
<!--              <div class="icon">-->
<!--                <img v-bind:src="sale.sns_post_sale.video_picture_url" alt="">-->
<!--              </div>-->
<!--              <div class="contents">-->
<!--                <h3>{{ sale.sns_post_sale.title }}</h3>-->
<!--              </div>-->
<!--              <div class="btn sp" v-if="sale.readable">-->
<!--                <router-link :to="{ name: 'SnsPost', params: {post_id: sale.sns_post_sale.sns_post_id} }" class="linkBtn">-->
<!--                  講義動画へ-->
<!--                </router-link>-->
<!--              </div>-->
<!--              <div class="btn sp" v-else>-->
<!--                <router-link :to="{ name: 'SnsPostSale', params: {id: sale.sns_post_sale.id} }" class="linkBtn green">-->
<!--                  再レンタル-->
<!--                </router-link>-->
<!--              </div>-->
<!--            </div>-->
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
  },
  props: {
    sns_post_sales: null
  }
}
</script>

<style lang="scss">
  .order_group.expire {
    opacity: 0.8;
    background: #eee;
    pointer-events: none;
  }

</style>